var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNetlifyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "256px",
    height: "226px",
    viewBox: "0 0 256 226",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "netlify") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#05BDBA",
    points: "69.1805953 188.087106 66.7635841 188.087106 54.6985267 176.022048 54.6985267 173.605237 73.1428857 155.161078 85.9210874 155.161078 87.6247543 156.864745 87.6247543 169.642947"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#05BDBA",
    points: "54.6985267 51.6279666 54.6985267 49.2109554 66.7635841 37.145898 69.1805953 37.145898 87.6247543 55.590057 87.6247543 68.3682587 85.9210874 70.0721256 73.1428857 70.0721256"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.906229,149.197744 L143.3536,149.197744 L141.887515,147.731858 L141.887515,106.643468 C141.887515,99.3332396 139.014939,93.6670823 130.199028,93.4690977 C125.662183,93.350107 120.471588,93.4690977 114.924622,93.6868807 L114.092487,94.5388142 L114.092487,147.71206 L112.626401,149.177945 L95.0737724,149.177945 L93.6076869,147.71206 L93.6076869,77.5211437 L95.0737724,76.0550582 L134.577286,76.0550582 C149.930887,76.0550582 162.372315,88.4964862 162.372315,103.850087 L162.372315,147.731858 L160.906229,149.197744 Z",
    fill: "#014847"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#05BDBA",
    points: "71.6768002 122.888599 1.46602547 122.888599 0 121.422514 0 103.830288 1.46602547 102.364203 71.6768002 102.364203 73.1428857 103.830288 73.1428857 121.422514"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#05BDBA",
    points: "254.534115 122.888599 184.323 122.888599 182.856914 121.422514 182.856914 103.830288 184.323 102.364203 254.534115 102.364203 256 103.830288 256 121.422514"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#05BDBA",
    points: "117.876391 54.1241715 117.876391 1.46602547 119.342476 0 136.934702 0 138.400787 1.46602547 138.400787 54.1241715 136.934702 55.590057 119.342476 55.590057"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#05BDBA",
    points: "117.876391 223.786517 117.876391 171.128831 119.342476 169.662745 136.934702 169.662745 138.400787 171.128831 138.400787 223.786517 136.934702 225.252402 119.342476 225.252402"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetlifyIcon);
export default __webpack_public_path__ + "static/media/netlify-icon.776cd25042456425e3bbfdd0cba9435a.svg";
export { ForwardRef as ReactComponent };